import type { AuthConfig } from '../types/app-config';

const EXTERNAL_URL_PATTERN = /^https?:\/\//i;

export function isExternalAuthUrl(path: string): boolean {
  return EXTERNAL_URL_PATTERN.test(path);
}

export function normalizeAuthPath(path: string | undefined, fallback: string): string {
  if (!path || !path.trim()) return fallback;
  if (isExternalAuthUrl(path)) return path;
  return path.startsWith('/') ? path : `/${path}`;
}

export function getLoginPath(auth?: AuthConfig): string {
  return normalizeAuthPath(auth?.loginUrl, '/login');
}

export function getLogoutPath(auth?: AuthConfig): string {
  return normalizeAuthPath(auth?.logoutUrl, '/logout');
}

export function toRoutePath(path: string): string {
  return path.replace(/^\//, '');
}

export function isAuthEnabled(auth?: AuthConfig): boolean {
  return (auth?.provider ?? 'none') !== 'none';
}
